import React from 'react';
import Breadcrumbs from '../BreadcrumbsNav.js';

export default function Header() {
  return (
      <Breadcrumbs showTitle = {false}/>
  )
}
